import { combineReducers } from 'redux';

import auth from './views/auth/reducer';
import workflow from './views/workflow/reducer';

export default combineReducers({ auth, workflow });
